"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function onAdPlay(event) {
  if (!this.state.adHasPlayed) {
    this.props.onAdPlay(event);
    this.setState({
      adHasPlayed: true
    });
  } else {
    this.props.onAdResume(event);
  }
}

exports.default = onAdPlay;


//////////////////
// WEBPACK FOOTER
// ./~/react-jw-player/dist/create-event-handlers/on-ad-play.js
// module id = 1781
// module chunks = 1